import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem("lb-lang") === "en" ? "en" : "it";
    } catch {
      return "it";
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem("lb-lang", lang);
    } catch {}
    document.documentElement.lang = lang;
  }, [lang]);

  const tr = (section) => translations[section]?.[lang] || translations[section]?.it || {};

  return (
    <LangContext.Provider value={{ lang, setLang, tr, translations }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
